(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/bankid/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/app/bankid/assets/javascripts/prescript.js'); (function(svs) {
  'use strict';

  svs = svs || {};
  svs.app = svs.app || {};
  svs.app.bankid = svs.app.bankid || {};
  svs.app.bankid.views = svs.app.bankid.views || {};
  svs.app.bankid.logger =
    svs.app.bankid.logger || svs.core.log.getLogger('app:bankid');
})(svs);

 })(window);